import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue";
import _imports_0 from '@/assets/img/logo.png';
const _hoisted_1 = {
  id: "header",
  class: "container-fuild",
  style: {
    "box-shadow": "0 2px 4px rgba(0, 0, 0, 0.2)"
  }
};
const _hoisted_2 = {
  class: "header-nav container hidden-xs"
};
const _hoisted_3 = {
  class: "header-nav-wrapper"
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = {
  key: 0,
  class: "icon-chevron-down"
};
const _hoisted_6 = {
  key: 0
};
const _hoisted_7 = ["onClick"];
const _hoisted_8 = {
  class: "header-nav-m container-fuild visible-xs"
};
const _hoisted_9 = {
  class: "header-nav-m-menu text-center"
};
const _hoisted_10 = {
  id: "menu",
  class: "header-nav-m-wrapper collapse"
};
const _hoisted_11 = ["onClick"];
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { WOW } from 'wowjs';

// 使用路由

export default {
  __name: 'AppHeader',
  setup(__props) {
    const router = useRouter();

    // 响应式数据
    const navIndex = ref(sessionStorage.getItem('navIndex') ? Number(sessionStorage.getItem('navIndex')) : 0);
    const selectNavIndex = ref(sessionStorage.getItem('selectNavIndex') ? Number(sessionStorage.getItem('selectNavIndex')) : 3);
    const menuClass = ref("glyphicon");

    // 导航菜单数据
    const navList = ref([{
      name: "首页",
      path: "/",
      children: []
    }, {
      name: "解决方案",
      path: "/software",
      children: [{
        name: "行业解决方案",
        path: "/software",
        hash: "target-jie"
      }, {
        name: "AI算法",
        path: "/software",
        hash: "target-Ai"
      }, {
        name: "Toco-Cloud云服务",
        path: "/software",
        hash: "target-cloud"
      }]
    }, {
      name: "产品",
      path: "/service",
      children: []
    }, {
      name: "App",
      path: "/newsinformation",
      children: []
    }, {
      name: "关于我们",
      path: "/companyintroduction",
      children: []
    }, {
      name: "联系我们",
      path: "/contact",
      children: []
    }]);

    // 方法
    const home = () => {
      router.push("/");
    };
    const navClick = (index, path) => {
      if (navIndex.value == index) {
        return;
      }
      navIndex.value = index;
      sessionStorage.setItem('navIndex', index.toString());
      selectNavIndex.value = 3;
      sessionStorage.setItem('selectNavIndex', '3');
      router.replace({
        path: path
      });
    };
    const selectClick = (index, path, hash) => {
      if (selectNavIndex.value == index) {
        console.log(hash, path, index);
        return;
      }
      navIndex.value = 1;
      selectNavIndex.value = index;
      sessionStorage.setItem('selectNavIndex', index.toString());
      console.log(hash, path, 412412421);
      router.replace({
        path: path,
        query: {
          'refName': hash
        }
      });
    };
    const menuClick = () => {
      if (menuClass.value == "glyphicon") {
        menuClass.value = "glyphicon";
      } else {
        menuClass.value = "glyphicon";
      }
    };
    return (_ctx, _cache) => {
      const _component_router_link = _resolveComponent("router-link");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_withDirectives(_createElementVNode("div", {
        class: "header-nav-logo",
        onClick: _cache[0] || (_cache[0] = $event => home())
      }, [...(_cache[2] || (_cache[2] = [_createElementVNode("img", {
        src: _imports_0
      }, null, -1)]))], 512), [[_vShow, false]]), _createElementVNode("ul", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(navList.value, (item, index) => {
        return _openBlock(), _createElementBlock("li", {
          key: index,
          class: _normalizeClass(''),
          onClick: $event => navClick(index, item.path)
        }, [_createElementVNode("a", {
          href: "#",
          onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"])),
          style: _normalizeStyle(navIndex.value == index ? {
            'color': '#1e73be'
          } : {})
        }, [_createTextVNode(_toDisplayString(item.name) + " ", 1), item.children.length > 0 ? (_openBlock(), _createElementBlock("span", _hoisted_5)) : _createCommentVNode("", true), _createElementVNode("i", {
          class: "underline",
          style: _normalizeStyle(navIndex.value == index ? {
            opacity: '1',
            width: '100%',
            left: '0'
          } : {})
        }, null, 4)], 4), item.children.length > 0 ? (_openBlock(), _createElementBlock("dl", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (i, n) => {
          return _openBlock(), _createElementBlock("dt", {
            key: n,
            onClick: _withModifiers($event => selectClick(n, i.path, i.hash), ["prevent"])
          }, [_createElementVNode("a", {
            href: "#",
            style: _normalizeStyle(selectNavIndex.value == n ? {
              'color': '#1e73be'
            } : {})
          }, _toDisplayString(i.name), 5)], 8, _hoisted_7);
        }), 128))])) : _createCommentVNode("", true)], 8, _hoisted_4);
      }), 128)), _cache[3] || (_cache[3] = _createElementVNode("li", null, [_createElementVNode("a", {
        class: "login",
        href: "http://system.daguiot.com:8000",
        target: "_blank"
      }, "登录")], -1))])]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("div", {
        class: "header-nav-m-menu-wrapper",
        "data-toggle": "collapse",
        "data-target": "#menu",
        onClick: menuClick
      }, [_createElementVNode("span", {
        class: _normalizeClass(menuClass.value)
      }, [...(_cache[4] || (_cache[4] = [_createElementVNode("span", {
        class: "icon-menu"
      }, [_createElementVNode("span")], -1)]))], 2)]), _createElementVNode("ul", _hoisted_10, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(navList.value, (item, index) => {
        return _openBlock(), _createElementBlock("li", {
          key: index,
          class: _normalizeClass(index == navIndex.value ? 'active' : ''),
          onClick: $event => navClick(index),
          "data-toggle": "collapse",
          "data-target": "#menu"
        }, [_createVNode(_component_router_link, {
          to: {
            path: item.path,
            hash: item.hash
          },
          style: {
            "text-decoration": "none"
          }
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(item.name) + " ", 1), _cache[5] || (_cache[5] = _createElementVNode("i", {
            class: "underline"
          }, null, -1))]),
          _: 2
        }, 1032, ["to"])], 10, _hoisted_11);
      }), 128)), _cache[6] || (_cache[6] = _createElementVNode("li", {
        class: "login-phone"
      }, "登录", -1))])])])]);
    };
  }
};